import React, { useState } from "react";
import { motion } from "framer-motion";
import '../Scc/Contact.scss';  // Import SCSS file

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form submitted:", formData);
    alert("Message sent successfully!");
    setFormData({ name: "", email: "", message: "" });
  };

  return (
    <div className="contact min-h-screen flex flex-col justify-center items-center bg-gray-100 p-6">
      <motion.div
        className="form-container w-full max-w-xl bg-white p-8 rounded-xl shadow-lg"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <h2 className="form-title text-3xl font-bold text-center text-gray-800 mb-6">
          Contact Us
        </h2>

        <div className="contact-info text-gray-600 text-sm mb-6">
          <p>
            <strong>Address:</strong>
            <br />
            Gate No. 169, Talwade Road, Rupee Nagar,
            <br />
            Behind Saraswati English Medium School,
            <br />
            Pune-411062, Maharashtra, India.
          </p>
          <p className="mt-4">
            <strong>Email:</strong> mbjtechnologies22@gmail.com
          </p>
          <p>
            <strong>Phone:</strong> +91-XXXXXXXXXX
          </p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="input-group mb-4">
            <label className="form-label text-gray-700 font-medium mb-1">
              Name
            </label>
            <input
              type="text"
              name="name"
              required
              value={formData.name}
              onChange={handleChange}
              className="form-input"
            />
          </div>

          <div className="input-group mb-4">
            <label className="form-label text-gray-700 font-medium mb-1">
              Email
            </label>
            <input
              type="email"
              name="email"
              required
              value={formData.email}
              onChange={handleChange}
              className="form-input"
            />
          </div>

          <div className="input-group mb-4">
            <label className="form-label text-gray-700 font-medium mb-1">
              Message
            </label>
            <textarea
              name="message"
              rows="4"
              required
              value={formData.message}
              onChange={handleChange}
              className="form-textarea"
            ></textarea>
          </div>

          <button
            type="submit"
            className="submit-btn w-full bg-blue-800 hover:bg-blue-600 text-white py-3 rounded-md font-semibold transition duration-300"
          >
            Send Message
          </button>
        </form>
      </motion.div>

      <div className="footer-text text-gray-500 text-sm mt-6 text-center">
        © 2025 MBJ Technologies. All rights reserved.
      </div>
    </div>
  );
};

export default Contact;
